import { AnimatePresence, motion } from 'motion/react'
import { SeedInput } from '@/components/SeedInput'
import { transitions } from '@/lib/motion/presets'
import type { SeedInputRevealProps } from './SeedInputReveal.types'

export function SeedInputReveal({ show, ...seedProps }: SeedInputRevealProps) {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          key="seed-input"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={transitions.collapse}
          className="-mx-1 overflow-hidden"
        >
          {/* The inset keeps the clip off the input's focus ring. Horizontal only:
              a negative margin-bottom would out-specify the parent's space-y. */}
          <div className="p-1">
            <SeedInput {...seedProps} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
